export type TeamBirthdaysTranslations = {
  label: string;
  title: string;
  today: string;
  tomorrow: string;
  yesterday: string;
};

export const teamBirthdaysTranslations: TeamBirthdaysTranslations = {
  label: 'Birthdays',
  title: 'Upcoming birthdays',
  today: 'Today',
  tomorrow: 'Tomorrow',
  yesterday: 'Yesterday',
};
